let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kMFx9")).then(() => parcelRequire('fXnqO'));